import React, {Component} from 'react';
import '../App.css';
import '../css/addAsset.css';
import axios from 'axios';
import cookie from 'react-cookies';
import Select from 'react-select';
import Autocomplete from "./Autocomplete";
import AutoFillAsset from "./AutoFillAsset";
import Requestgame from "./Requestgame";

import Modal from "react-bootstrap/Modal";
import AssetPreview from './AssetPreview';

class AddAsset extends Component{
	//call the constructor method
	constructor(props){
		super(props);
		
		this.state = {
			assetName: '',
			enhancementCells: null,
			enhancement_list: [],
			enhancement_value_list: [],
			enhancementValue: 0,
			selectedGameOption: {value: 0, label: ''},
			selectedAssetType: {value: 0, label: ''},
			selectedRarity: {value: 0, label: ''},
			selectedEnhancement: null,
			selectedCurrencyType: { value: 0, label: this.props.dataLanguage['real_world'] },
			selectedCurrency: {value: 0, label: ''},
			selectedTargetCurrency: null,
			orgCurrencyList: [],
			currencyList: [],
			gameCurrencyList: [],
			defaultCurrency: null,
			price: '',
			targetPrice: '',
			description: '',
			main_image_url: '/assets/images/placeholder.jpg',
			assetMainImageUrl: '',
			submitStatus: true,
			gameTitle: '',
			showRequestGamePopup: false,
			addNewVideo: true,
			videoUrl: '',
			videoUrlList: [],
			videoIdList: [],
			isUploading: false,
			showAssetPreviewPopup: false,
			userName: '',
			userAvatar: '',
			assetTypeLabelList: [],
			rarityLabelList: [],
			gameNameList: [],
			gameTypeList: [],
			enhancementLabelList: [],
			orgAssetTemplateList: [],
			assetTemplateList: [],
			assetTemplateLabelList: [],
			selectedAssetTemplate: null,
			gameList: [],
			message: ''
		}
		
		this.getGameList = this.getGameList.bind(this);
		this.changeMainImage = this.changeMainImage.bind(this);
		this.changeVideo = this.changeVideo.bind(this);
		this.gameTitleChangeHandler = this.gameTitleChangeHandler.bind(this);
		this.getAssetTemplateList = this.getAssetTemplateList.bind(this);
		this.setTemplateFields = this.setTemplateFields.bind(this);
		this.setWrapperRefSelectGamePopup = this.setWrapperRefSelectGamePopup.bind(this);
		this.setWrapperRefAssetNamePopup = this.setWrapperRefAssetNamePopup.bind(this);
		this.setWrapperRefAssetTypePopup = this.setWrapperRefAssetTypePopup.bind(this);
		this.setWrapperRefRarityPopup = this.setWrapperRefRarityPopup.bind(this);
		this.setWrapperRefEnhancementsPopup = this.setWrapperRefEnhancementsPopup.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}
	
	componentWillMount(){
		document.addEventListener('mousedown', this.handleClickOutside);

		this.setState({
			authFlag : false
		})

		if (!cookie.load('cookieId')) {
			this.props.closeAddAssetPopup();
		}
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);

		var currencyType = [];
		currencyType.push({ value: 0, label: this.props.dataLanguage['real_world'] });
		currencyType.push({ value: 1, label: this.props.dataLanguage['game_currency'] });

		this.setState({
			currencyType: currencyType
		});
		
		this.getGameList();
		this.getGameTypeList();
		this.getAssetTypeList();
		this.getRarityList();
		this.getEnhancementList();
		this.getCurrencyList();
		this.getUserName();
	}

	setWrapperRefSelectGamePopup(node) {
		this.selectGamePopup = node;
	}

	setWrapperRefAssetNamePopup(node) {
		this.selectAssetNamePopup = node;
	}

	setWrapperRefAssetTypePopup(node) {
		this.selectAssetTypePopup = node;
	}

	setWrapperRefRarityPopup(node) {
		this.selectRarityPopup = node;
	}

	setWrapperRefEnhancementsPopup(node) {
		this.selectEnhancementsPopup = node;
	}


	handleClickOutside(event) {
		if (this.selectGamePopup && !this.selectGamePopup.contains(event.target)) {
			this.refs.selectGame.closeDropDown();
		}

		if (this.selectAssetNamePopup && !this.selectAssetNamePopup.contains(event.target)) {
			this.refs.assetName.closeDropDown();
		}

		if (this.selectAssetTypePopup && !this.selectAssetTypePopup.contains(event.target)) {
			this.refs.assetType.closeDropDown();
		}

		if (this.selectRarityPopup && !this.selectRarityPopup.contains(event.target)) {
			this.refs.rarity.closeDropDown();
		}

		if (this.selectEnhancementsPopup && !this.selectEnhancementsPopup.contains(event.target)) {
			this.refs.enhancements.closeDropDown();
		}
	}

	getUserName() {
		if ( cookie.load('cookieId') ) {
			const userdata = {
				userid: cookie.load('cookieId')
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/getUserInfo',userdata)
				.then(response => {
					if(response.status === 200){
						this.setState({
							userName : response.data[0].first_name + " " + response.data[0].last_name
						})
					}
				})

			this.getUserAvatar();
		}
	}	

	getUserAvatar() {
		const userdata = {
			userid: cookie.load('cookieId')
		}		

		axios.defaults.withCredentials = true;
		
		axios.post(window.$backend_url + '/getUserAvatar', userdata)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						userAvatar: response.data
					})
				}

			})
			.catch(error => {
			})
	}

	getAssetTemplateList(gameId) {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getAssetTemplate?gameId=' + gameId)
			.then(response => {
				if ( response.status === 200 ) {
					// this.setState({
					// 	orgAssetTemplateList: response.data
					// });

					const assetTemplateList = response.data.filter(
						(template) =>
						template.gameId == gameId
					);

					var assetTemplateLabelList = [];

					if (assetTemplateList.length) {
						for (var i=0; i<assetTemplateList.length; i++) {
							assetTemplateLabelList.push(assetTemplateList[i].name);
						}
					}

					this.setState({
						assetTemplateList: assetTemplateList,
						assetTemplateLabelList: assetTemplateLabelList
					})
				}
			})
			.catch(error => {
				console.log(error);
			})
	}

	getGameList() {
		var gameList = [];
		var gameNameList = [];
		var currentGame = null;

		for (var i=0; i<this.props.gameList.length; i++) {
			gameList.push({ value: this.props.gameList[i].id, label: this.props.gameList[i].name });
			gameNameList.push(this.props.gameList[i].name);

			if (this.props.currentGameId === this.props.gameList[i].id) {
				currentGame = { value: this.props.gameList[i].id, label: this.props.gameList[i].name };
			}
		}

		this.setState({
			gameList: gameList,
			gameNameList: gameNameList,
			selectedGameOption: currentGame
		});
	}

	getGameTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameTypes')
			.then(response => {
				if ( response.status === 200 ) {
					var gameTypeList = [];

					for (var i=0; i<response.data.length; i++) {
						gameTypeList.push({ value: response.data[i].id, label: response.data[i].type });
					}
					
					this.setState({
						gameTypeList: gameTypeList
					});
				}
			})
	}

	getAssetTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getAssetTypeList')
			.then(response => {
				if ( response.status === 200 ) {
					var assetTypeList = [];
					var assetTypeLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						assetTypeList.push({ value: response.data[i].id, label: response.data[i].name });
						assetTypeLabelList.push(response.data[i].name);
					}

					this.setState({
						assetTypeList: assetTypeList,
						assetTypeLabelList: assetTypeLabelList
					});
				}
			})
	}

	getRarityList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getRarityList')
			.then(response => {
				if ( response.status === 200 ) {
					var rarityList = [];
					var rarityLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						rarityList.push({ value: response.data[i].id, label: response.data[i].name });
						rarityLabelList.push(response.data[i].name);
					}

					this.setState({
						rarityList: rarityList,
						rarityLabelList: rarityLabelList
					});
				}
			})
	}

	getEnhancementList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getEnhancementList')
			.then(response => {
				if ( response.status === 200 ) {
					var enhancementList = [];
					var enhancementLabelList = [];

					for (var i=0; i<response.data.length; i++) {
						enhancementList.push({ value: response.data[i].id, label: response.data[i].name });
						enhancementLabelList.push(response.data[i].name);
					}

					this.setState({
						enhancementList: enhancementList,
						enhancementLabelList: enhancementLabelList
					});
				}
			})
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					var currencyList1 = [];
					var currencyList2 = [];
					var temp = null;

					for (var i=0; i<response.data.length; i++) {
						if (response.data[i].type == 1) {
							currencyList1.push({ value: response.data[i].id, label: response.data[i].name });
						} else {
							currencyList2.push({ value: response.data[i].id, label: response.data[i].name });
						}

						if (response.data[i].status === 2) {
							temp = { value: response.data[i].id, label: response.data[i].name };
						}
					}

					this.setState({
						orgCurrencyList: response.data,
						currencyList: currencyList1,
						gameCurrencyList: currencyList2,
						selectedCurrency: temp,
						selectedTargetCurrency: temp,
						defaultCurrency: temp
					});
				}
			})
	}

	checkLogin(){
		
	}

	changeAssetTemplateHandler(val) {
		this.setState({
			assetName: val
		})
		// const filteredOptions = this.state.assetTemplateList.filter(
		// 	(assetTemplate) =>
		// 	assetTemplate.name.toLowerCase().indexOf(val.toLowerCase()) > -1
		// );

		// if (val === ''){
		// 	this.setState({
		// 		selectedAssetTemplate: null
		// 	})
		// } else if (filteredOptions.length) {
		// 	this.setState({
		// 		selectedAssetTemplate: filteredOptions[0]
		// 	})
		// } else {
		// 	let temp = { value: 0, label: val };
		// 	this.setState({
		// 		selectedAssetTemplate: temp
		// 	})
		// }
	}

	changeAssetTemplateHandlerWithClick(val) {
		const filteredOptions = this.state.assetTemplateList.filter(
			(assetTemplate) =>
			assetTemplate.name.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (filteredOptions.length) {
			this.setState({
				selectedAssetTemplate: filteredOptions[0]
			}, function(){
				this.setTemplateFields();
			})
		}
	}

	setTemplateFields() {
		if (this.state.selectedAssetTemplate.mainImageUrl == null) {
			this.state.selectedAssetTemplate.mainImageUrl = '';
		}

		this.setState({
			assetName: this.state.selectedAssetTemplate.name,
			assetMainImageUrl: this.state.selectedAssetTemplate.mainImageUrl
		})

		fetch(this.state.selectedAssetTemplate.mainImageUrl)
		.then(res => {
			if(res.type === "cors"){
				this.setState({
					main_image_url: this.state.selectedAssetTemplate.mainImageUrl
				})
			}else{
				this.setState({
					main_image_url: '/assets/images/placeholder.jpg'
				})
			}
		})
		.catch(err=>{
			this.setState({
				main_image_url: '/assets/images/placeholder.jpg'
			})
		})

		var filteredOptions = this.state.assetTypeList.filter(
			(assetType) =>
			assetType.value == this.state.selectedAssetTemplate.assetType
		);

		if (filteredOptions.length) {
			this.setState({
				selectedAssetType: filteredOptions[0]
			})

			this.refs.assetType.setValue(filteredOptions[0].label);
		} else {
			this.refs.assetType.setValue("");
		}

		// var filteredOptions = this.state.gameList.filter(
		// 	(game) =>
		// 	game.value == this.state.selectedAssetTemplate.gameId
		// );

		// if (filteredOptions.length) {
		// 	this.setState({
		// 		selectedGame: filteredOptions[0]
		// 	})

		// 	this.refs.selectGame.setValue(filteredOptions[0].label);
		// } else {
		// 	this.refs.selectGame.setValue("");
		// }
	}

	changeAssetTypeHandler(val) {
		const filteredOptions = this.state.assetTypeList.filter(
			(assetType) =>
			assetType.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (val === ''){
			this.setState({
				selectedAssetType: null
			})
		} else if (filteredOptions.length) {
			this.setState({
				selectedAssetType: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedAssetType: temp
			})
		}
	}

	changeRarityHandler(val) {
		const filteredOptions = this.state.rarityList.filter(
			(rarity) =>
			rarity.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (val === ''){
			this.setState({
				selectedRarity: null
			})
		} else if (filteredOptions.length) {
			this.setState({
				selectedRarity: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedRarity: temp
			})
		}
	}

	changeEnhancementHandler(val) {
		const filteredOptions = this.state.enhancementList.filter(
			(enhancement) =>
			enhancement.label.toLowerCase().indexOf(val.toLowerCase()) > -1
		);

		if (val === ''){
			this.setState({
				selectedEnhancement: null
			})
		} else if (filteredOptions.length) {
			this.setState({
				selectedEnhancement: filteredOptions[0]
			})
		} else {
			let temp = { value: 0, label: val };
			this.setState({
				selectedEnhancement: temp
			})
		}
	}

	changeCurrencyTypeHandler = selectedCurrencyType => {
		this.setState({ 
			selectedCurrencyType: selectedCurrencyType,
			price: 0,
			targetPrice: 0,
			selectedCurrency: this.state.defaultCurrency,
			selectedTargetCurrency: this.state.defaultCurrency
		});

		if (selectedCurrencyType.value) {
			this.setState({
				selectedCurrency: null
			})
		}
	}

	changeCurrencyHandler = selectedCurrency => {
		this.setState({ 
			selectedCurrency: selectedCurrency
		});
	}

	changeTargetCurrencyHandler = selectedTargetCurrency => {
		this.setState({ 
			selectedTargetCurrency: selectedTargetCurrency
		});
	}

	changeDescriptionHandler(e) {
		this.setState({description: e.target.value});
	}

	changeAssetNameHandler(e) {
		this.setState({assetName: e.target.value});
	}

	changePriceHandler(e) {
		const price = (e.target.validity.valid) ? e.target.value : this.state.price;
		this.setState({ price });
	}

	changeTargetPriceHandler(e) {
		const targetPrice = (e.target.validity.valid) ? e.target.value : this.state.targetPrice;
		this.setState({ targetPrice });
	}

	mainImageSelect = (e) => {
		e.preventDefault();
		document.getElementById('maing_image').click();
	}

	changeMainImage(e){
		if (e.target.files[0]) {
			this.setState({
				assetMainImageUrl: '',
				main_image_url: URL.createObjectURL(e.target.files[0]),
				file: e.target.files[0]
			})
		}
	}

	changeAssetMainImageUrlHandler(e) {
		this.setState({
			file: null,
			assetMainImageUrl: e.target.value
		})

		var url = e.target.value;
		fetch(url)
		.then(res => {
			if(res.type === "cors"){
				this.setState({
					main_image_url: url
				})
			}else{
				this.setState({
					main_image_url: '/assets/images/placeholder.jpg'
				})
			}
		})
		.catch(err=>{
			this.setState({
				main_image_url: url
			})
		})
	}

	uploadVideo = (e) => {
		e.preventDefault();

		if (this.state.videoUrlList.length < 4 && this.state.videoUrl) {
			this.setState({
				addNewVideo: false,
				isUploading: true
			})

			const data = {
					userid: cookie.load('cookieId'),
					videoUrl: this.state.videoUrl
				};

			axios.defaults.withCredentials = true;			

			axios.post(window.$backend_url + '/upload_asset_video_url', data)
				.then(response => {
					let tempList = this.state.videoUrlList;
					tempList.push(this.state.videoUrl);

					this.setState({
						videoUrlList: tempList
					})

					if (tempList.length < 4) {
						this.setState({
							addNewVideo: true
						})
					}

					tempList = this.state.videoIdList;
					tempList.push(response.data);
					this.setState({
						videoIdList: tempList,
						isUploading: false,
						videoUrl: ''
					})

					this.reloadVideoList();
				})
		}
	}

	selectVideo = (e) => {
		e.preventDefault();
		document.getElementById('select_video').click();
	}

	closeVideo = (e) => {
		e.preventDefault();
		
		var remove_index = parseInt(e.target.getAttribute('rel'));

		var tempList = this.state.videoIdList.filter((x,i) => i !== remove_index);
		this.setState({
			videoIdList: tempList
		})

		tempList = this.state.videoUrlList.filter((x,i) => i !== remove_index);
		this.setState({
			videoUrlList: tempList,
			addNewVideo: true
		})

		this.reloadVideoList();
	}

	reloadVideoList() {
		let videos = this.state.videoUrlList.map((video, index) => {
			if (video.includes("youtube")) {
				var video_id = video.split('v=')[1];
				if (video.includes("embed")) {
					video_id = video.split("embed/")[1];
				}

				var ampersandPosition = video_id.indexOf('&');
				if (ampersandPosition !== -1) {
				  video_id = video_id.substring(0, ampersandPosition);
				}

				var video_image = "https://img.youtube.com/vi/" + video_id + "/0.jpg";

				return(
					<div className="video_container" key={index}>
						<img src={video_image} alt="" />
						<div className="btn_wrap">
							<button className="close_video" onClick={this.closeVideo} rel={index}></button>
						</div>
					</div>
				)
			} else {
				return(
					<div className="video_container" key={index}>
						<video>
							<source src={video} type="video/mp4" />
						</video>
						<div className="btn_wrap">
							<button className="close_video" onClick={this.closeVideo} rel={index}></button>
						</div>
					</div>
				)
			}
		});

		this.setState({
			videos: videos
		});
	}

	changeVideo(e) {
		if (e.target.files[0]) {
			let tempList = this.state.videoUrlList;
			tempList.push(URL.createObjectURL(e.target.files[0]));

			this.setState({
				videoUrlList: tempList,
				addNewVideo: false,
				isUploading: true
			})

			if (tempList.length < 4) {
				this.setState({
					addNewVideo: true
				})
			}

			const formData = new FormData();
			formData.append('file', e.target.files[0]);

			const config = {
				headers: {
					'content-type': 'multipart/form-data'
				}
			};

			axios.post(window.$backend_url + '/upload_asset_video', formData, config)
			.then(response => {
				tempList = this.state.videoIdList;
				tempList.push(response.data);
				this.setState({
					videoIdList: tempList,
					isUploading: false
				})

				this.reloadVideoList();
			})
			.catch(error => {
				this.setState({
					isUploading: false
				})
			})
			
		} else {
			this.setState({
				addNewVideo: true
			})
		}
	}

	changeAssetVideoUrlHandler(e) {
		this.setState({
			videoUrl: e.target.value
		})
	}

	handleValidation(){
		let formIsValid = true;

		if(this.state.selectedCurrency.value == 0){
			formIsValid = false;
			this.setState({
				message : this.props.dataLanguage['select_currency']
			});
		}

		if(this.state.selectedRarity.value == 0){
			formIsValid = false;
			this.setState({
				message : this.props.dataLanguage['select_rarity']
			});
		}

		if(this.state.selectedAssetType.value == 0){
			formIsValid = false;
			this.setState({
				message : this.props.dataLanguage['select_asset_type']
			});
		}

		if(!this.state.assetName){
			formIsValid = false;
			this.setState({
				message : this.props.dataLanguage['asset_name_required']
			});
		}

		if(!this.state.selectedGameOption){
			formIsValid = false;
			this.setState({
				message : this.props.dataLanguage['select_game']
			});
		}

		return formIsValid;
	}

	submitNewAsset = (e) => {
		e.preventDefault();
		
		if (this.state.submitStatus && !this.state.isUploading && this.handleValidation()) {
			this.props.closeAddAssetPopup();

			this.setState({
				submitStatus: false
			})

			var price = this.state.price;
			const filteredOptions = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.id == this.state.selectedCurrency.value
			);

			if (filteredOptions.length) {
				price = price / filteredOptions[0].rate;
			}

			const data = {
					userId: cookie.load('cookieId'),
					assetName: this.state.assetName,
					gameId: this.state.selectedGameOption.value,
					assetType: this.state.selectedAssetType,
					rarity: this.state.selectedRarity,
					enhancementList: this.state.enhancement_list,
					enhancementValues: this.state.enhancement_value_list,
					currencyId: this.state.selectedCurrency.value,
					price: price,
					description: this.state.description,
					videoIdList: this.state.videoIdList,
					mainImageUrl: this.state.assetMainImageUrl
				};

			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/add_asset', data)
				.then(response => {
					if ( this.state.file ) {
						const formData = new FormData();
						formData.append('userId', cookie.load('cookieId'));
						formData.append('gameId', this.state.selectedGameOption.value);
						formData.append('assetId', response.data);
						formData.append('file', this.state.file);

						const config = {
							headers: {
								'content-type': 'multipart/form-data'
							}
						};

						axios.post(window.$backend_url + '/upload_asset_main_image', formData, config)
							.then(response => {
								// this.props.closeAddAssetPopup();
							})
					} else {
						// this.props.closeAddAssetPopup();
					}

					this.props.history.push('/assets');
				})
		}			
	}

	removeEnhancement(e) {
		var temp = this.state.enhancement_list.filter((x,i) => i !== e.target.getAttribute('rel'));
		this.setState({
			enhancement_list: temp
		})

		temp = this.state.enhancement_value_list.filter((x,i) => i !== e.target.getAttribute('rel'));
		this.setState({
			enhancement_value_list: temp
		})

		let enhancements = this.state.enhancement_list.map((enhancement, index) => {
						return <div key={index} className="enhancement_cell" onClick={this.removeEnhancement.bind(this)} rel={index}>+{this.state.enhancement_value_list[index]} {enhancement.label}</div>
					});

		this.setState({
			enhancementCells: enhancements
		})
	}

	enhancementValueChangeHandler = (e) => {
		const enhancementValue = (e.target.validity.valid) ? e.target.value : this.state.enhancementValue;
		this.setState({ enhancementValue });
	}

	addEnhancement(e) {
		e.preventDefault();

		if (this.state.selectedEnhancement && this.state.enhancementValue > 0){
			this.state.enhancement_list.push(this.state.selectedEnhancement);
			this.state.enhancement_value_list.push(this.state.enhancementValue);
			
			let enhancements = this.state.enhancement_list.map((enhancement, index) => {
							return <div key={index} className="enhancement_cell" onClick={this.removeEnhancement.bind(this)} rel={index}>+{this.state.enhancement_value_list[index]} {enhancement.label}</div>
						});

			this.setState({
				enhancementCells: enhancements
			})

			this.setState({
				selectedEnhancement: null,
				enhancementValue: 0
			})
		}
	}

	toggleRequestGamePopup(e) {
		e.preventDefault();

		this.setState({
			showRequestGamePopup: !this.state.showRequestGamePopup,
			selectedGameType: null,
			gameTitle: ''
		})
	}

	gameTitleChangeHandler(gameTitle) {
		this.setState({gameTitle: gameTitle});

		const filteredOptions = this.state.gameList.filter(
			(game) =>
			game.label.toLowerCase().indexOf(gameTitle.toLowerCase()) > -1
		);

		if (gameTitle === ''){
			this.setState({
				selectedGameOption: null,
				assetTemplateList: [],
				assetTemplateLabelList: []
			})
		} else if (filteredOptions.length) {
			this.setState({
				selectedGameOption: filteredOptions[0]				
			})

			if (filteredOptions.length == 1) {
				this.getAssetTemplateList(filteredOptions[0].value);
			}
		} else {
			let temp = { value: 0, label: gameTitle };
			this.setState({
				selectedGameOption: temp,
				assetTemplateList: [],
				assetTemplateLabelList: []				
			})
		}
	}

	changeGameTypeHandler = selectedGameType => {
		this.setState({ 
			selectedGameType: selectedGameType
		})
	}

	sendRequestGame(e) {
		e.preventDefault();

		if (this.state.gameTitle && this.state.selectedGameType) {
			const gameData = {
				userId: cookie.load('cookieId'),
				title : this.state.gameTitle,
				gameType: this.state.selectedGameType
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/sendRequestGame', gameData)
				.then(response => {
					if(response.status === 200){
						this.setState({
							showRequestGamePopup: false
						})
					}
				})
				.catch(error => {
					this.setState({
						showRequestGamePopup: false
					})
				})
		}
	}

	previewAsset = (e) => {
		e.preventDefault();
		this.toggleAssetPreviewPopup();
	}

	toggleAssetPreviewPopup() {
		this.setState({
			showAssetPreviewPopup: !this.state.showAssetPreviewPopup
		})
	}

	converteCurrency() {
		if (this.state.selectedCurrency && this.state.selectedTargetCurrency && this.state.price) {
			const fromCurrency = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.id == this.state.selectedCurrency.value
			);

			const toCurrency = this.state.orgCurrencyList.filter(
				(currency) =>
				currency.id == this.state.selectedTargetCurrency.value
			);

			var temp = parseFloat(this.state.price) / parseFloat(fromCurrency[0].rate) * parseFloat(toCurrency[0].rate);
			this.setState({
				targetPrice: parseFloat(temp.toFixed(2))
			})
		}
	}
  
	render(){
		const { selectedCurrency } = this.state;
		const { selectedTargetCurrency } = this.state;
		const { selectedCurrencyType } = this.state;

		const customStyle = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'solid 3px #ffd33f',
				borderRadius: '20px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		const customStyle2 = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'none',
				borderRadius: '20px 0 0 20px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		return(			
			<div className="modal-login custom-modal">
				<div className="modal-logo">
					<img alt="logo" src="/assets/images/logo.png" />
				</div>
				<h2 className="text-center">{this.props.dataLanguage['create_asset']}</h2>
				<form className="add-asset-form">
					{ this.state.message ?
						<p className="message-text">{ this.state.message }</p>
					: null }
					<div className="row">
						<div className="col-md-6 col-12">
							<div className="form-group">
								<label>{this.props.dataLanguage['game']}</label>
								<div className="game_request_wrap">
									<div className="custom_autocomplete" ref={this.setWrapperRefSelectGamePopup}>
										<Requestgame
											ref = "selectGame"
											dataLanguage = {this.props.dataLanguage} 
											options = {this.state.gameNameList}
											value={this.state.gameTitle}
											gameTitleChangeHandler = {this.gameTitleChangeHandler.bind(this)}
											gameTypeList = {this.state.gameTypeList}
											changeGameTypeHandler = {this.changeGameTypeHandler.bind(this)}
											selectedGameType = {this.state.selectedGameType}
											sendRequestGame = {this.sendRequestGame.bind(this)}
											placeholder={this.props.dataLanguage['select'] + '...'} />
									</div>
								</div>
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['asset_name']}</label>
								<div className="custom_autocomplete" ref={this.setWrapperRefAssetNamePopup}>
									<AutoFillAsset
										ref = "assetName"
										options = {this.state.assetTemplateLabelList}
										changeValue = {this.changeAssetTemplateHandler.bind(this)}
										changeValueWithClick = {this.changeAssetTemplateHandlerWithClick.bind(this)}
									/>
								</div>
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['asset_type']}</label>
								<div className="custom_autocomplete" ref={this.setWrapperRefAssetTypePopup}>
									<Autocomplete
										ref = "assetType"
										options = {this.state.assetTypeLabelList}
										changeValue = {this.changeAssetTypeHandler.bind(this)}
									/>
								</div>
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['rarity']}</label>
								<div className="custom_autocomplete" ref={this.setWrapperRefRarityPopup}>
									<Autocomplete
										ref = "rarity"
										options = {this.state.rarityLabelList}
										changeValue = {this.changeRarityHandler.bind(this)}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-12">
							<div className="form-group">
								<label>{this.props.dataLanguage['main_image']}</label>
								<div className="main_image_container">
									<img alt="" src={ this.state.main_image_url } />
									<button type="button" className="btn_change_charactorImage" onClick={this.mainImageSelect}>{this.props.dataLanguage['change_pic']}</button> 
								</div>
								<input type="file" accept=".png,.jpg" onChange={this.changeMainImage} id="maing_image" name="maing_image" className="hidden" />
							</div>
							<div className="form-group">
								<input value={this.state.assetMainImageUrl} onChange={this.changeAssetMainImageUrlHandler.bind(this)} type="url" className="form-control" name="mainImageUrl" placeholder={this.props.dataLanguage['url'] + '...'} />
							</div>
							<div className="form-group">
								<label>{this.props.dataLanguage['upload_video']}</label>
								<input value={this.state.videoUrl} onChange={this.changeAssetVideoUrlHandler.bind(this)} type="url" className="form-control" name="videoUrl" placeholder={this.props.dataLanguage['url'] + '...'} />
								<div className="btn_upload_out">
									<button className="btn_yellow btn_center" onClick={this.uploadVideo.bind(this)}>{this.props.dataLanguage['upload']}</button>
								</div>
								<input type="file" accept=".mp4, *.avi" onChange={this.changeVideo} id="select_video" name="select_video" className="hidden" />
								<div className="video_wrap">
									{ this.state.videos ?
										this.state.videos
									: null}
									{ this.state.isUploading ? 
										<div>
											<div className="btn_select_video_out uploading"></div>
										</div>
									: null }
									{ this.state.addNewVideo ?
										<div className="btn_select_video_out">
											<button className="btn_select_video" onClick={this.selectVideo}></button>
										</div>
									: null }
								</div>
							</div>
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['enhancements']}</label>
						<div className="flex asset_enhancements">
							<div className="select_container">
								<div className="custom_autocomplete" ref={this.setWrapperRefEnhancementsPopup}>
									<Autocomplete
										ref = "enhancements"
										options = {this.state.enhancementLabelList}
										changeValue = {this.changeEnhancementHandler.bind(this)}
									/>
								</div>
							</div>
							<span className="plus_inhancement"> + </span>
							<input type="text" pattern="[0-9]*" className="form-control" name="asset_enhancement_number" onChange = {this.enhancementValueChangeHandler} value={this.state.enhancementValue}/>
							<button className="btn_yellow" onClick={this.addEnhancement.bind(this)}>{this.props.dataLanguage['add']}</button>
						</div>
						<div className="asset_enhancement_list">
							{this.state.enhancementCells ?
								<div className="">
									{this.state.enhancementCells}
								</div>
							: null }
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['price']}</label>
						<div className="row converter_wrap">
							<div className="col-md-4 col-12">
								<Select styles={customStyle} options={this.state.currencyType} onChange={this.changeCurrencyTypeHandler} value={selectedCurrencyType} />
							</div>
							<div className="col-md-3 col-5">
								<div className="twoInput">
									<div className="half">
										{ this.state.selectedCurrencyType.value == 0 ?
											<Select styles={customStyle2} options={this.state.currencyList} onChange={this.changeCurrencyHandler} value={selectedCurrency} />
										:
											<Select styles={customStyle2} options={this.state.gameCurrencyList} onChange={this.changeCurrencyHandler} value={selectedCurrency} />
										}
									</div>
									<div className="half">
										<input type="text" pattern="[0-9.]*" value={this.state.price} onChange={this.changePriceHandler.bind(this)} className="form-control" />
									</div>
								</div>
							</div>
							<div className="col-md-1 col-2">
								<img className="converter rotating" onClick={this.converteCurrency.bind(this)} alt="converter" src="/assets/images/converter.png" />
							</div>
							<div className="col-md-3 col-5">
								<div className="twoInput">
									<div className="half">
										<Select styles={customStyle2} options={this.state.currencyList} onChange={this.changeTargetCurrencyHandler} value={selectedTargetCurrency} />
									</div>
									<div className="half">
										<input type="text" pattern="[0-9.]*" value={this.state.targetPrice} onChange={this.changeTargetPriceHandler.bind(this)} className="form-control" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="form-group">
						<label>{this.props.dataLanguage['description']}</label>
						<textarea className="form-control" rows="5" value={this.state.description} onChange={this.changeDescriptionHandler.bind(this)} />
					</div>
					<div className="text-center">
						{ this.state.isUploading ? 
							<button onClick = {this.submitNewAsset} className="btn-submit disabled">{this.props.dataLanguage['upload_asset']}</button>
						:
							<button onClick = {this.submitNewAsset} type="submit" className="btn-submit">{this.props.dataLanguage['upload_asset']}</button>
						}
						<button onClick = {this.previewAsset} className="btn-submit btn-update-setting">{this.props.dataLanguage['preview_asset']}</button>
					</div>
				</form>
				{this.state.showAssetPreviewPopup ?  
					<Modal show={this.state.showAssetPreviewPopup} onHide={this.toggleAssetPreviewPopup.bind(this)} animation={false} className="previewModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AssetPreview 
							selectedGame = {this.state.selectedGameOption}
							userName = {this.state.userName}
							userAvatar = {this.state.userAvatar}
							assetName = {this.state.assetName}
							assetType = {this.state.selectedAssetType}
							assetRarity = {this.state.selectedRarity}
							assetEnhancements = {this.state.enhancement_list}
							assetEnhancementValues = {this.state.enhancement_value_list}
							assetImage = {this.state.main_image_url}
							currency = {this.state.selectedCurrency}
							price = {this.state.price}
							description = {this.state.description}
							videoUrlList = {this.state.videoUrlList}
							dataLanguage={this.props.dataLanguage}
							closeCharacterCharacterPopup={this.toggleAssetPreviewPopup.bind(this)} 
						/>
					</Modal>
				: null  
				}
			</div>
		)
	}
}

export default AddAsset;


// WEBPACK FOOTER //
// ./src/components/AddAsset.js